import { PaymentsListModel } from "@src/models/payment/payments-list.model";
import { types } from "mobx-state-tree";

const PaymentsControllerModel = types.model("PaymentsController", {
  list: types.optional(PaymentsListModel, { url: "/payments" }),
});

export const PaymentsController = PaymentsControllerModel.create();
